import Marty from "marty";
import catchError from "../utils/functions/catchApiError";

let gatewayAPI = Marty.createStateSource({
    type: "http",
    createTransaction(token, customer, shopify, callbackUrl){
        return this.post({
            url: "/stripe",
            body: { token, customer, shopify, callbackUrl }
        }).then(catchError("Error creating stripe customer"));
    },
    shopifyCallback(url, body) {
        return this.post({
            url,
            body
        }).then(catchError("Error sending data back to shopify"));
    }
});

export default gatewayAPI;



/** WEBPACK FOOTER **
 ** ./app/sources/gatewayAPI.js
 **/